<div class="delete-message-modal-container">
    <div class="modal-header">
        <div class="modal-title">
            DELETE
        </div>
        <div class="modal-close-button" (click)="!disabled ? onCloseButtonClick() : ''">
            <img class="closeIcon" src=""/>
        </div>
    </div>
    <div class="modal-body">
        <div class="delete-message-container">
            <div class="delete-message-text">
                This configuration will be permanently deleted, and insights won't be generated anymore based on this configuration.
            </div>
            <div class="delete-message-text">
                Are you sure you want to Delete?
            </div>
        </div>
        <div class="delete-buttons-main-container">
            <div class="delete-buttons-sub-container">
                <span>
                    <button (click)="onCloseButtonClick()" class="cancel-button" [disabled]="disabled">
                        <div class="cancel-button-text">
                            NO, CANCEL
                        </div>
                    </button>
                </span>
                <span>
                    <button (click)="onConfirmButtonClick()" class="confirm-button" [disabled]="disabled">
                        <div class="confirm-button-text">
                            YES, CONFIRM
                        </div>
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>